import { getTailwindConfig } from "@/utils/getTailwindConfig";

export function ProgressRing({ progress }: { progress: number }) {
  const strokeWidth = 10;
  const viewBoxSize = 100; // Use a fixed size for SVG viewbox
  const radius = (viewBoxSize - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - progress * circumference;

  const fullConfig = getTailwindConfig();
  const primaryColor =
    typeof fullConfig.theme?.colors?.primary === "string" ?
      fullConfig.theme.colors.primary
    : "#000000";

  return (
    <div className="flex h-full w-full items-center justify-center">
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
        preserveAspectRatio="xMidYMid meet"
      >
        <circle
          stroke="lightgray"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          r={radius}
          cx={viewBoxSize / 2}
          cy={viewBoxSize / 2}
        />
        <circle
          stroke={primaryColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          style={{ strokeDashoffset }}
          r={radius}
          cx={viewBoxSize / 2}
          cy={viewBoxSize / 2}
        />
      </svg>
    </div>
  );
}
